import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
/**
 * A route guard component that checks if the user is authenticated.
 * If authenticated, renders the child routes via <Outlet />.
 * If not, redirects to the login page.
 *
 * @component
 * @returns {JSX.Element}
 */

const ProtectedRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  console.log(isAuthenticated);

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
